<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2002</span></div>
    </div>
    <div class="view-wrap yr2002">


<FullYearStats fullGames='16' fullCompletions='320' fullAttempts='526' fullYards='3,284' fullPct='60.8' fullTDs='17' fullINTs='16' fullYPG='205.3' fullRating='76.9'></FullYearStats>
  
  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">


      <h1 class="content-headline">Schottenheimer opens up the QB competition</h1>

<p>

After losing their last nine games in 2001, Marty Schottenheimer opened up the quarterback competition in his 1st season as head coach. Brees would eventually beat out Doug Flutie for the starting role.<br/><br/>

After starting the season 6-2, the Chargers reversed that number to finish it out, ending the season at 8-8 but improving on their record from the previous year by three wins.<br/><br/>

<!--<VideoBtn button="Video1" vidUrl="https://www.youtube.com/embed/ByUzsQR3_TY">I WISH WE COULD EMBED OUR VIDEOS LIKE THIS VIDEOO</VideoBtn> -->


</p>

      <p class="image-paragraph">
       <img src="../assets/brees-2002-1.jpg" class="img-portrait img-50w" alt="Drew Brees talks to Marty Schottenheimer during a game">

        <!--<span class="blockquote">BREES LIGHTS IT UP HIS FIRST YEAR FOR THE SAINTS</span>-->

        
      </p>

      </div> <!--end text-flex-->
    </div>
  </div>


<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2002 Touchdown Tally"> 2002 TOUCHDOWN TALLY</h1>
</div>

</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2002 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2002 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2002 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2002 - Slide4"></div>
</flickity>




<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2001">«2001</router-link></div>
  <div class="year-pagination-section year-pagination-current">2002</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2003">2003»</router-link></div>
</div>

    </div>
  </div>
</template>






<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';

import axios from 'axios';

export default {
  name: 'yr2002',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2002 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2002-top.jpg",
      image1: "brees-2002-slide-1.jpg",
      image2: "brees-2002-slide-2.jpg",
      image3: "brees-2002-slide-3.jpg",
      image4: "brees-2002-slide-4.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2002;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },
  mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

},
  beforeMount() {
    // this.tds = this.$parent.y2002;
    // console.log(this.tds, "From y2002.vue's Parent ");
  }
}
</script>

<style>




</style>


// WEBPACK FOOTER //
// src/views/yr2002.vue